<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<ng-container>
    <fuse-vertical-navigation class="navegate print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
        [name]="'mainNavigation'" [navigation]="navigation.default" [opened]="!isScreenSmall">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex items-center h-20 p-6 pb-0">
                <!-- Light version -->
                <div class=" lg:flex">
                    <img class="w-32" *ngIf="environment.scheme !== 'dark'"
                        src="assets/images/logo/unexa-logo-horizontal-light.svg" alt="Logo image" />
                    <img class="w-32" *ngIf="environment.scheme == 'dark'"
                        src="assets/images/logo/unexa-logo-horizontal-dark.svg" alt="Logo image" />
                </div>
            </div>
        </ng-container>
    </fuse-vertical-navigation>

    <!-- Logo -->
    <!-- <div class="flex items-center mx-2 lg:mr-8">
        <div class="hidden lg:flex">
            <img class="w-32"
                *ngIf ="environment.scheme !== 'dark'"
                src="assets/images/logo/unexa-logo-horizontal-light.svg" alt="Logo image"
            />
            <img class="w-32"
                *ngIf ="environment.scheme == 'dark'"
                src="assets/images/logo/unexa-logo-horizontal-dark.svg" alt="Logo image"
            />
        </div>
        <img
            class="flex lg:hidden w-8"
            src="assets/images/logo/unexa-logo-solo.svg" alt="Logo image"
        />
    </div> -->
</ng-container>
<!-- Navigation -->

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <div class="flex items-center mx-2 lg:mr-8" *ngIf="showHeaderLogo == true">
            <div class="hidden lg:flex">
                <img class="w-32" *ngIf="environment.scheme !== 'dark'"
                    src="assets/images/logo/unexa-logo-horizontal-light.svg" alt="Logo image" />
                <img class="w-32" *ngIf="environment.scheme == 'dark'"
                    src="assets/images/logo/unexa-logo-horizontal-dark.svg" alt="Logo image" />
            </div>
            <img class="flex lg:hidden w-8" src="assets/images/logo/unexa-logo-solo.svg" alt="Logo image" />
        </div>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <!-- <p>{{userEmail}}</p> -->
            <button (click)="switchScheme()" title="Cambiar modo" class="button-icon">
                <mat-icon [svgIcon]="
                        isDarkMode
                            ? 'heroicons_outline:sun'
                            : 'heroicons_outline:moon'
                    "></mat-icon>
            </button>
            <button (click)="checkStatus()" title="Ver estado de las apps" class="button-icon" *ngIf="!hasAlerts">
                <mat-icon svgIcon="heroicons_outline:server-stack" style="color: green !important"></mat-icon>
            </button>

            <button (click)="checkStatus()" title="Ver estado de las apps" class="button-icon" *ngIf="hasAlerts">
                <mat-icon svgIcon="heroicons_solid:server-stack" style="color: red !important;"></mat-icon>
            </button>
            <!-- <button (click)="signOut()" title="Cerrar sesión" class="button-icon">
                <mat-icon
                    svgIcon="heroicons_outline:arrow-left-on-rectangle"
                ></mat-icon>
            </button> -->
            <button mat-icon-button [matMenuTriggerFor]="userActions">
                <span class="relative">
                    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                    <span class="absolute bottom-0 right-0 h-2 w-2 rounded-full mb-px mr-px"></span>
                </span>
            </button>
        </div>
    </div>

    <app-status-bar *ngIf="userRole !== 'ADMINISTRADOR'"></app-status-bar>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div
        class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">{{ version }}</span>
    </div>

</div>

<!-- Quick chat -->
<quick-chat #quickChat="quickChat"></quick-chat>


<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Ingresaste como:</span>
            <span class="mt-1.5 text-md font-medium">{{ userEmail }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Rol asignado:</span>
            <span class="mt-1.5 text-md font-medium">{{userRole}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="seeProfileData()">
        <mat-icon [svgIcon]="'heroicons_outline:user'"></mat-icon>
        <span>Ver mi usuario</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Cerrar sesión</span>
    </button>
</mat-menu>
